import axios from '../axios'
import { formatSelectOption as format } from '@/utils'
const computedWidth = data => {
  if (Array.isArray(data)) {
    const arr = data.map(({ label, columns = [] }) => {
      const width = label ? label.length * 18 : 0
      const w = computedWidth(columns)
      return Math.max(width, w)
    })
    return Math.max(...arr)
  }
  return 0
}
export const getReportList = data => axios.post('/bzmj/home/datareprot/report', data, { loading: 'loading' }).then(({ data = {} }) => {
  const { title = [], list = [], pages = {} } = data.data || {}
 
  const { counts: total = 0 } = pages
  const columns = title.map(item => {
    const w = item.label ? item.label.length * 18 : 0
    const width = Math.max(120, w, computedWidth(item.columns))
    return {
      ...item,
      width
    }
  })
  return {
    columns,
    list,
    total
  }
})

/**
 * 下拉数据
 */
const cache = {}
cache.selects = {}
export const selectOptions = (check_type, business_id) => {
  // if (cache.selects[check_type]) return cache.selects[check_type]
  return (cache.selects[check_type] = axios.post('/select/dataReportSelect', { check_type, business_type_id: business_id }, { loading: 'reportselect' }).then(({ data = {} }) => {
    const {
      dealer_type_list: dealerTypeList,
      year_list: yearList
    } = data.data || {}
    return {
      dealerTypeList: format(dealerTypeList),
      yearList: format(yearList)
    }
  }, () => (cache.selects[check_type] = null)))
}
export const getDataReportYearPeriod = (business_id) => {
  // if (cache.selects[check_type]) return cache.selects[check_type]
  return (cache.selects[business_id] = axios.post('/select/dataReportyear?business_id=' + business_id, { loading: 'reportselect' }).then(({ data = {} }) => {
    const {
      year_list: yearList
    } = data.data || {}
    return {
      yearList: format(yearList)
    }
  }, () => (cache.selects[business_id] = null)))
}

export const getCheckTypeSelect = () => axios.post('/select/dataReportCheckTypeSelect', null, { loading: 'check_type' }).then(({ data = {} }) => {
  const { check_type_list } = data.data || {}
  return {
    checkType: format(check_type_list),
    checkTypeAlias: format(check_type_list, 'alias')
  }
})

cache.module = {}
const loadModules = (data) => {
  const key = JSON.stringify(data)
  if (cache.module[key]) return cache.module[key]
  return (cache.module[key] = axios.post('/bzmj/anlysis/report/select/modul', data, { loading: 'moduleselect', cancel: `moduleselect-${key}` }).then(
    ({ data = {} }) => {
      let rows = data.data || []
      rows = Array.isArray(rows) ? rows : []
      const modules = []
      const childModule = []
      rows.forEach(({ module, child_modules = [] }) => {
        modules.push({ label: module, value: module })
        const child = child_modules.map(label => ({ label, module, value: label }))
        childModule.push(...child)
      })
      return { modules, childModule }
    },
    () => (cache.module[key] = null)
  ))
}

export const getModule = data => loadModules(data).then(data => data.modules)

export const getChildModule = (data, module) => loadModules(data).then(data => module ? data.childModule.filter(item => item.module === module) : [])

export const updateData = data => axios.post('/bzmj/home/datareprot/updateReport', data, { loading: 'update' })
export default {
  computedWidth,
  getReportList,
  selectOptions,
  getDataReportYearPeriod,
  getCheckTypeSelect,
  loadModules,
  getModule,
  getChildModule,
  updateData
}
